// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faFont, faSquare, faAlignJustify, faSun,
  faLightbulb, faMoon, faPlayCircle, faArrowsAlt, faTimesCircle,
  faEye, faThumbsDown, faThumbsUp, faFrown, faMeh, faSmile,
  faTable, faDice, faCheckSquare, faCaretSquareRight, faCheckCircle, faClock,
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Fullscreen from 'vue-fullscreen';
import { ClientTable } from 'vue-tables-2';
import App from './App';
import router from './router';
import BootstrapVue from 'bootstrap-vue';
import VModal from 'vue-js-modal';

Vue.use(VModal, { dialog: true });

// import '../node_modules/bootstrap/dist/css/bootstrap.css';
// import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);

// Require the main Sass manifest file
require('written-number');

library.add(faSquare, faFont, faAlignJustify, faSun, faLightbulb, faMoon, faPlayCircle, faArrowsAlt, faTimesCircle, faEye);
library.add(faThumbsDown, faThumbsUp, faFrown, faMeh, faSmile, faTable, faDice, faCheckSquare, faCaretSquareRight, faCheckCircle);
library.add(faClock, faExclamationTriangle);

Vue.component('font-awesome-icon', FontAwesomeIcon);
require('../node_modules/@fortawesome/fontawesome-free/css/all.min.css');
// require('../node_modules/@fortawesome/fontawesome-free/css/v4-shims.min.css');

Vue.use(ClientTable, {}, false, 'bootstrap4', 'default');
Vue.use(Fullscreen);
Vue.use(require('vue-moment'));

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')

